const state = {
  options: {
    hids: null,
    start: null,
    end: null,
    name: null,
    historySn: null,
    attendingName: null
  },
  pagination: {
    sort: 'time',
    order: 'ASC',
    size: 10,
    total: 0,
    current: 1,
    layout: 'total, sizes, prev, pager, next, jumper',
    sizes: [10, 20, 30]
  }
}

const mutations = {
  setOptions (state, options) {
    for (let key in state.options) {
      if (options.hasOwnProperty(key)) {
        state.options[key] = options[key]
      }
    }
  },
  setPagination (state, pagination) {
    for (let key in state.pagination) {
      if (pagination.hasOwnProperty(key)) {
        state.pagination[key] = pagination[key]
      }
    }
  }
}

const actions = {
  updateOptions ({commit}, payload) {
    return new Promise(function (resolve) {
      commit('setOptions', payload)
      resolve()
    })
  }
}

const getters = {
  pagination (state) {
    return state.pagination
  },
  options: function (state) {
    return state.options
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
